var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSlim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15,26.85l-5-5a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0L5,25.29V.5a.5.5,0,0,1,1,0V25.29l4.15-4.14a.49.49,0,0,1,.7.7l-5,5a.36.36,0,0,1-.16.11.5.5,0,0,1-.38,0A.36.36,0,0,1,5.15,26.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSlim);
export default __webpack_public_path__ + "static/media/arrow-down-slim.0805e3b8c69fcdfb3e9a0a3a32aa4199.svg";
export { ForwardRef as ReactComponent };